export { default } from './balance-card-insight-v2'
